// probaworkflow configs
import Configslayout from "@/layout/config_base_layout/ConfigsLayout.vue";
import GlobalOverview from "@/views/config_views/GlobalOverview/GlobalOverview.vue";
import ProjectManagement from "@/views/config_views/ProjectManagement/ProjectManagement.vue";
import UserManagement from "@/views/config_views/UserManagement/UserManagement.vue";
import RolesManagement from "@/views/config_views/RolesManagement/ManageRole.vue";
import EntityConfigs from "@/views/config_views/EntityConfigs/EntityConfigs.vue";
import EntityConfigDetail from "@/views/config_views/EntityConfigDetail/EntityConfigDetail.vue";
import EntitySubsystemBindings from "@/views/config_views/EntitySubsystemBindings/EntitySubsystemBindings.vue";
import CreateForm from "@/views/config_views/FormManagement/CreateForm/CreateForm.vue";
import CreateSections from "@/views/config_views/FormManagement/FormBuilder/create_sections/CreateSections.vue";
import ManageQuestions from "@/views/config_views/FormManagement/FormBuilder/manage_questions/ManageQuestions.vue";
import PreviewForm from "@/views/config_views/FormManagement/PreviewForm/PreviewForm.vue";
import ViewTemplate from "@/views/config_views/TemplateManagement/ViewTemplates/ViewTemplate.vue"
import UploadTemplate from "@/views/config_views/TemplateManagement/UploadTemplate/UploadTemplate.vue"
import CreateWorkflow from "@/views/config_views/WorkflowManagement/CreateWorkflow/CreateWorkflow.vue";
import ConfigureWorkflow from "@/views/config_views/WorkflowManagement/ConfigureWorkflow/ConfigureWorkflow.vue";
import ManageStatus from "@/views/config_views/StatusManagement/ManageStatus.vue";
import CreateRiskFramework from "@/views/config_views/RiskManagement/CreateFramework/CreateRiskFramework.vue";
import ComplianceManagement from "@/views/config_views/ComplianceManagement/ComplianceManagement.vue";
import DocumentsWorkflow from "@/views/config_views/TemplateManagement/Esigining/DocumentsWorkflow.vue";
import ManageSubEntities from "@/views/config_views/EntityManagement/ManageSubEntities/ManageSubEntities.vue";
import SubEntityRequirements from "@/views/config_views/EntityManagement/SubEntityRequirements/SubEntityRequirements.vue";
import ManageDocuments from "@/views/config_views/DocumentsManagement/ManageDocuments.vue";
import VerificationServices from "@/views/config_views/AutoVerificationManagment/VerificationServices/VerificationServices.vue";
import ConfigureVerificationServices from "@/views/config_views/AutoVerificationManagment/ConfigureVerificationServices/ConfigureVerificationServices.vue"
import VerificationForm from "@/views/config_views/AutoVerificationManagment/VerificationForm/VerificationForm.vue"
import FormQuestionMapping from "@/views/config_views/AutoVerificationManagment/FormQuestionMapping/FormQuestionMapping.vue"
import ConfigureVerificationForm from "@/views/config_views/AutoVerificationManagment/ConfigureVerificationForm/ConfigureVerificationForm.vue"
import ManualVerification from "@/views/config_views/ManualVerification/ManualVerification.vue"
import ManualVerificationBinding from "@/views/config_views/ManualVerification/ManualVerificationBinding/ManualVerificationBinding.vue"
import CommandCenter from "@/views/onboarding_system_views/Overview/CommandCenter/CommandCenter.vue"
import MyQueue from "@/views/onboarding_system_views/Overview/MyQueue/MYQueue.vue"
import QueueForm from "@/views/onboarding_system_views/Overview/QueueForm/QueueForm.vue"
import ManageTemplates from "@/views/onboarding_system_views/Overview/Templates/ManageTemplates.vue"
import ManageSupplier from "@/views/onboarding_system_views/Journeys/Supplier/ManageSupplier.vue"
import ManageEmployees from "@/views/onboarding_system_views/Journeys/Employees/ManageEmployees.vue"
import ManagePartner from "@/views/onboarding_system_views/Journeys/Partner/ManagePartner.vue"
import ManageIntern from "@/views/onboarding_system_views/Journeys/Intern/ManageIntern.vue"
import ManageClient from "@/views/onboarding_system_views/Journeys/Client/ManageClient.vue"
import OnboardingManageDocuments from "@/views/onboarding_system_views/Gates/Documents/ManageDocuments.vue"
import OnboardingManageVerification from "@/views/onboarding_system_views/Gates/Verification/ManageVerification.vue"
import OnboardingRiskReview from "@/views/onboarding_system_views/Gates/Risk/RiskReview.vue"
import OnboardingManageApprovals from "@/views/onboarding_system_views/Gates/Approvals/ManageApprovals.vue"
import OnboardingManageAgreements from "@/views/onboarding_system_views/Gates/Contracts/ManageAgreements.vue"
import EsigningSetup from "@/views/onboarding_system_views/Gates/EsigningManagement/EsigningSetup/EsigningSetup.vue"
import SigningTracker from "@/views/onboarding_system_views/Gates/EsigningManagement/SigningTracker/SigningTracker.vue"
import OnboardingManageTraining from "@/views/onboarding_system_views/Gates/Training/ManageTraining.vue"
import OnboardingManageActivation from "@/views/onboarding_system_views/Gates/Activation/ManageActivation.vue"
import OnboardingGateStatusQueue from "@/views/onboarding_system_views/Gates/StatusQueue/GateStatusQueue.vue"
import OnboardingManageReports from "@/views/onboarding_system_views/Insight/Reports/ManageReports.vue"
import OnboardingComplyonSync from "@/views/onboarding_system_views/Insight/Complyonsync/ComplyonSync.vue"
import OnboardingAuditLog from "@/views/onboarding_system_views/Insight/Auditlog/AuditLog.vue"
import OnboardingIntakePortal from "@/views/onboarding_system_views/Applicant/IntakePortal/IntakePortal.vue"

const probaworkflows_routes = [{
    path: "/",
    name: "GlobalConfigsBase",
    component: Configslayout,

    children: [
        {
            path: "/onboarding-system/overview/command-centre",
            name: "CommandCentre",
            component: CommandCenter,
            meta: { onboardingSystem: true, onboardingSection: 'Overview', onboardingTitle: 'Command centre' }
        },
        {
            path: "/onboarding-system/overview/my-queue",
            name: "MyQueue",
            component: MyQueue,
            meta: { onboardingSystem: true, onboardingSection: 'Overview', onboardingTitle: 'My queue' }
        },
        {
            path: "/onboarding-system/overview/my-queue/:applicationId/form",
            name: "MyQueueForm",
            component: QueueForm,
            meta: { onboardingSystem: true, onboardingSection: 'Overview', onboardingTitle: 'Assigned form' }
        },
        {
            path: "/onboarding-system/journeys/:journeyId",
            name: "DynamicOnboardingJourney",
            component: MyQueue,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Journey' }
        },
        {
            path: "/onboarding-system/overview/templates",
            name: "ManageTemplates",
            component: ManageTemplates,
            meta: { onboardingSystem: true, onboardingSection: 'Overview', onboardingTitle: 'Templates' }
        },
        {
            path: "/onboarding-system/journeys/supplier",
            name: "ManageSupplier",
            component: ManageSupplier,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Supplier' }
        },
        {
            path: "/onboarding-system/journeys/employees",
            name: "ManageEmployees",
            component: ManageEmployees,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Employee' }
        },
        {
            path: "/onboarding-system/journeys/partner",
            name: "ManagePartner",
            component: ManagePartner,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Partner' }
        },
        {
            path: "/onboarding-system/journeys/intern",
            name: "ManageIntern",
            component: ManageIntern,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Intern' }
        },
        {
            path: "/onboarding-system/journeys/client",
            name: "ManageClient",
            component: ManageClient,
            meta: { onboardingSystem: true, onboardingSection: 'Journeys', onboardingTitle: 'Client' }
        },
        {
            path: "/onboarding-system/gates/documents",
            name: "OnboardingManageDocuments",
            component: OnboardingManageDocuments,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Documents' }
        },
        {
            path: "/onboarding-system/gates/verification",
            name: "OnboardingManageVerification",
            component: OnboardingManageVerification,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Verification' }
        },
        {
            path: "/onboarding-system/gates/verification/:applicationId",
            name: "OnboardingVerificationCase",
            component: OnboardingManageVerification,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Verification case' }
        },
        {
            path: "/onboarding-system/gates/manual-verification",
            name: "OnboardingManageManualVerification",
            component: OnboardingManageVerification,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Manual Verification', gateMode: 'manual' }
        },
        {
            path: "/onboarding-system/gates/manual-verification/:applicationId",
            name: "OnboardingManualVerificationCase",
            component: OnboardingManageVerification,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Manual Verification case', gateMode: 'manual' }
        },
        {
            path: "/onboarding-system/gates/risk-review",
            name: "OnboardingRiskReview",
            component: OnboardingRiskReview,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Risk review' }
        },
        {
            path: "/onboarding-system/gates/risk-review/:applicationId",
            name: "OnboardingRiskReviewCase",
            component: OnboardingRiskReview,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Risk review case' }
        },
        {
            path: "/onboarding-system/gates/approvals",
            name: "OnboardingManageApprovals",
            component: OnboardingManageApprovals,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Approvals' }
        },
        {
            path: "/onboarding-system/gates/contracts",
            name: "OnboardingManageAgreements",
            component: OnboardingManageAgreements,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Contracts' }
        },
        {
            path: "/onboarding-system/gates/e-signing",
            name: "OnboardingEsigningSetup",
            component: EsigningSetup,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'E-signing' }
        },
        {
            path: "/onboarding-system/gates/e-signing/:applicationId",
            name: "OnboardingEsigningCase",
            component: EsigningSetup,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'E-signing case' }
        },
        {
            path: "/onboarding-system/gates/e-signing/signing-tracker",
            name: "OnboardingSigningTracker",
            component: SigningTracker,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Signing tracker' }
        },
        {
            path: "/onboarding-system/gates/training",
            name: "OnboardingManageTraining",
            component: OnboardingManageTraining,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Training' }
        },
        {
            path: "/onboarding-system/gates/activation",
            name: "OnboardingManageActivation",
            component: OnboardingManageActivation,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Activation' }
        },
        {
            path: "/onboarding-system/gates/status-queue",
            name: "OnboardingGateStatusQueue",
            component: OnboardingGateStatusQueue,
            meta: { onboardingSystem: true, onboardingSection: 'Gates', onboardingTitle: 'Status queue' }
        },
        {
            path: "/onboarding-system/insight/reports",
            name: "OnboardingManageReports",
            component: OnboardingManageReports,
            meta: { onboardingSystem: true, onboardingSection: 'Insight', onboardingTitle: 'Reports' }
        },
        {
            path: "/onboarding-system/insight/complyon-sync",
            name: "OnboardingComplyonSync",
            component: OnboardingComplyonSync,
            meta: { onboardingSystem: true, onboardingSection: 'Insight', onboardingTitle: 'Complyon sync' }
        },
        {
            path: "/onboarding-system/insight/audit-log",
            name: "OnboardingAuditLog",
            component: OnboardingAuditLog,
            meta: { onboardingSystem: true, onboardingSection: 'Insight', onboardingTitle: 'Audit log' }
        },
        {
            path: "/onboarding-system/applicant/intake-portal",
            name: "OnboardingIntakePortal",
            component: OnboardingIntakePortal,
            meta: { onboardingSystem: true, onboardingSection: 'Applicant', onboardingTitle: 'Intake portal' }
        },
        {
            path: "/overview",
            name: "GlobalOverview",
            component: GlobalOverview
        },
        {
            path: "/projects",
            name: "ProjectManagement",
            component: ProjectManagement,
        },
        {
            path: "/users",
            name: "UserManagement",
            component: UserManagement,
        },
        {
            path: "/roles",
            name: "RolesManagement",
            component: RolesManagement,
        },
        {
            path: "/entity-configs",
            name: "EntityConfigs",
            component: EntityConfigs
        },
        {
            path: "/entity-configs/:entityTypeId",
            name: "EntityConfigDetail",
            component: EntityConfigDetail
        },
        {
            path: "/entity-configs/:entityTypeId/bind-subsystems",
            name: "EntitySubsystemBindings",
            component: EntitySubsystemBindings
        },
        // Form Management Hub
        {
            path: "/create_form",
            name: "CreateForm",
            component: CreateForm
        },
        {
            path: "/create_sections",
            name: "CreateSections",
            component: CreateSections
        },
        {
            path: "/manage_questions",
            name: "ManageQuestions",
            component: ManageQuestions,
        },
        {
            path: "/preview_form",
            name: "PreviewForm",
            component: PreviewForm
        },
        {
            path: "/view_template",
            name: "ViewTemplate",
            component: ViewTemplate
        },
        {
            path: "/upload_template",
            name: "UploadTemplate",
            component: UploadTemplate
        },
        {
            path: "/documents_workflow",
            name: "DocumentsWorkflow",
            component: DocumentsWorkflow
        },

        // Workflow Management Hub
        {
            path: "/create_workflow",
            name: "CreateWorkflow",
            component: CreateWorkflow
        },
        {
            path: "/configure_workflow",
            name: "ConfigureWorkflow",
            component: ConfigureWorkflow
        },

        // Manage Documents
        {
            path: "/documents",
            name: "ManageDocuments",
            component: ManageDocuments
        },

        // Child Entities
        {
            path: "/manage_sub_entity",
            name: "ManageSubEntities",
            component: ManageSubEntities
        },
        {
            path: "/sub_entity_requirements",
            name: "SubEntityRequirements",
            component: SubEntityRequirements
        },

        // Status Management Hub
        {
            path: "/manage_status",
            name: "ManageStatus",
            component: ManageStatus
        },
        {
            path: "/compliance_management",
            name: "ComplianceManagement",
            component: ComplianceManagement
        },
        {
            path: "/verification_services",
            name: "VerificationServices",
            component: VerificationServices
        },
        // Risk Management Hub
        {
            path: "/create_riskframework",
            name: "CreateRiskFramework",
            component: CreateRiskFramework
        },
        {
            path: "/configure_verification_services",
            name: "ConfigureVerificationServices",
            component: ConfigureVerificationServices
        },
        {
            path: "/configure_verification_form",
            name: "ConfigureVerificationForm",
            component: ConfigureVerificationForm
        },
        {
            path: "/verification_form",
            name: "VerificationForm",
            component: VerificationForm
        },
        {
            path: "/form_question_mapping",
            name: "FormQuestionMapping",
            component: FormQuestionMapping
        },
        {
            path: "/manual_verification",
            name: "ManualVerification",
            component: ManualVerification
        },
        {
            path: "/manual_verification_binding",
            name: "ManualVerificationBinding",
            component: ManualVerificationBinding
        },
    ]

   }
]



export default probaworkflows_routes;
